'use client';
import { useEffect, useState } from 'react';
import { useRouter, usePathname, useSearchParams } from 'next/navigation';

export default function AuthGuard({ children }: { children: React.ReactNode }) {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    // skip check on login page
      const isShared = pathname.startsWith('/s/') || 
                   pathname.startsWith('/shared/') || 
                   searchParams.get('shared') === 'true' || 
                   searchParams.get('hideMenu') === 'true' ||
                   searchParams.get('public') === 'true';

    if (pathname === '/login' || pathname === '/landing' || isShared) {
      setIsAuthenticated(true);
      return;
    }

    const user = localStorage.getItem('user');
    if (user) {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
      const fullPath = window.location.pathname + window.location.search;
      router.push(`/login?redirect=${encodeURIComponent(fullPath)}`);
    }
  }, [pathname, router]);

  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950">
        <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (isAuthenticated === false && pathname !== '/login') {
    return null; // Don't render children while redirecting
  }

  return <>{children}</>;
}
